import { Button } from "primereact/button";
import { Card } from "primereact/card";
import React from "react";
import CorporateFareOutlinedIcon from "@mui/icons-material/CorporateFareOutlined";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { RoutePaths } from "src/resources/enum";
import { ProgressSpinner } from "primereact/progressspinner";
import { formatNumber, isCivilDefenseUser } from "src/utils/helpers";

const AssignedPropertiesCard = () => {
  const { t } = useTranslation(["common", "dashboard"]);
  const navigate = useNavigate();
  const { totalCount, buildings, establishments, buildingHasNoActiveContracts } = useSelector(
    (state: any) => state.dashboard.buildingStats
  );

  const { isBuildingStatisticsDataLoaded } = useSelector(
    (state: any) => state.dashboard
  );

  return (
    <Card className="card card-3-3">
      <div className="card-content">
        <div className="d-flex gap-2 justify-content-between align-items-center pt-2">
          <h6 className="card-title">{t("bmcProperties")}</h6>
          {!isCivilDefenseUser() && (
            <Button
              label={t("seeAll")}
              className="edit-btn light-primary-btn m-0"
              onClick={() => navigate(RoutePaths.AssignedBuildings)}
            />
          )}
        </div>
        {isBuildingStatisticsDataLoaded && (
          <>
            <div className="d-flex gap-1 align-items-center justify-content-center m-auto">
              <span className="total-properties" title={totalCount}>
                {formatNumber(totalCount)}
              </span>
              <span>{t("properties")}</span>
            </div>
            <div className="d-flex justify-content-between mt-4 align-items-stretch">
              <div className="d-flex gap-2 flex-column align-items-center assigned-properties-inner-card">
                <CorporateFareOutlinedIcon fontSize="large" />
                <h4 className="m-0" title={establishments}>
                  {formatNumber(establishments)}
                </h4>
                <span>{t("establishments")}</span>
              </div>
              <div className="d-flex gap-2 flex-column align-items-center assigned-properties-inner-card">
                <MapsHomeWorkOutlinedIcon fontSize="large" />
                <h4 className="m-0" title={buildings}>
                  {formatNumber(buildings)}
                </h4>
                <span>{t("buildings")}</span>
              </div>
            </div>
            <div className="inActive-contracts mt-2 p-2 d-flex gap-2 align-items-baseline" title={buildingHasNoActiveContracts}>
              <span className="total-properties">{formatNumber(buildingHasNoActiveContracts)}</span>
              <p className="m-0">{t("inActiveAssignedPropertiesMsg")}</p>
            </div>

            <p className="note mt-2">
              {t("notAffectedByFilterDate", {
                field: t("bmcProperties"),
              })}
            </p>
          </>
        )}
        {!isBuildingStatisticsDataLoaded && <ProgressSpinner />}
      </div>
    </Card>
  );
};

export default AssignedPropertiesCard;
